import React from 'react'

import Skeleton from 'react-loading-skeleton'

import useStyles from './styles'

function FacebookPostSkeleton() {
  const classes = useStyles({})

  return (
    <div className={classes.facebookPost}>
      <div className={classes.previewArea}>
        <div className={classes.preview}>
          <Skeleton width="100%" height="50px" />
        </div>
      </div>
      <div className={classes.body}>
        <div className={classes.postId}>
          <Skeleton width="40%" height="10px" />
        </div>
      </div>
    </div>
  )
}

export default FacebookPostSkeleton
